import React, { useState } from 'react';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import FlatButton from 'material-ui/FlatButton';
import CheckboxNormal from 'components/ui/CheckboxNormal';

import styled from 'styled-components';
import { AccentColor } from 'helpers/AccentColorHelper';
import { colors } from 'helpers/ColorHelper';
import { getTranslatedString } from 'helpers/i18n';

const StyledDialogTitle = styled.h3`
  text-align: center;
  margin: 0;
`;

const StyledDialogText = styled.p`
  text-align: left;
  white-space: pre-line;
`;

const StyledError = styled.div`
  color: ${colors.YUHU_RED};
`;

const agreementRequiredErrorText = getTranslatedString(
  'tenantPortal.amenities.agreeToTermsAndConditionsError'
);

const AmenityBookingWaiver = ({
  showBookingWaiver = false,
  onCloseCallback,
  onSubmitCallback,
  fullScreen = false,
  waiver,
}) => {
  const [hasAgreedToWaiver, setHasAgreedToWaiver] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = () => {
    if (hasAgreedToWaiver) {
      onSubmitCallback();
      setHasAgreedToWaiver(false);
      setError(null);
    } else {
      setError(agreementRequiredErrorText);
    }
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      open={showBookingWaiver}
      onClose={() => {
        onCloseCallback();
        setHasAgreedToWaiver(false);
        setError(null);
      }}
      aria-labelledby="amenity-booking-waiver"
      classes={{
        paper: 'form-dialog',
      }}
      disableBackdropClick
    >
      <DialogTitle>
        <StyledDialogTitle>
          {getTranslatedString('tenantPortal.amenities.amenityWaiverHeader')}
        </StyledDialogTitle>
      </DialogTitle>
      <DialogContent>
        <StyledDialogText>{waiver}</StyledDialogText>
        <CheckboxNormal
          name="hasAgreedToWaiver"
          value={hasAgreedToWaiver}
          checked={hasAgreedToWaiver}
          onChange={() => setHasAgreedToWaiver(!hasAgreedToWaiver)}
          aria-labelledby="agree-to-terms"
        >
          {getTranslatedString('tenantPortal.amenities.agreeToTermsAndConditions')}
        </CheckboxNormal>
        {error && <StyledError>{error}</StyledError>}
      </DialogContent>
      <DialogActions style={{ display: 'block', padding: '0px 18px 12px' }}>
        <FlatButton
          primary={true}
          style={{ color: AccentColor() }}
          onClick={() => {
            onCloseCallback();
            setHasAgreedToWaiver(false);
            setError(null);
          }}
          aria-labelledby="back"
        >
          {getTranslatedString('back')}
        </FlatButton>
        <FlatButton
          primary={true}
          backgroundColor={AccentColor()}
          hoverColor="grey"
          style={{
            color: 'white',
            height: '40px',
            margin: 'auto',
            float: 'right',
          }}
          onClick={handleSubmit}
          aria-labelledby="book"
        >
          {getTranslatedString('book')}
        </FlatButton>
      </DialogActions>
    </Dialog>
  );
};

export default withMobileDialog()(AmenityBookingWaiver);
